<template>
  <div class="ele-body ele-body-card">
    <el-row :gutter="15">
      <el-col :md="10" :sm="12">
        <el-card shadow="never" header="录取通知书设置">
          <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="150px">
            <el-form-item label="背景样式：" prop="backgroundType">
              <el-radio-group v-model="editForm.backgroundType">
                <el-radio :label="1">样式一</el-radio>
                <el-radio :label="2">样式二</el-radio>
                <el-radio :label="3">样式三</el-radio>
                <el-radio :label="4">样式四</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="学校名称:" prop="schoolName" style="width: 60%">
              <el-input v-model="editForm.schoolName" placeholder="请输入学校名称" clearable />
            </el-form-item>
            <el-form-item label="校长姓名:" prop="teacherName" style="width: 60%">
              <el-input v-model="editForm.teacherName" placeholder="请输入校长姓名" clearable />
            </el-form-item>
            <el-form-item label="是否显示身份证号：" prop="idCardState">
              <el-switch v-model="editForm.idCardState" :active-value="1" :inactive-value="0" />
            </el-form-item>
            <el-form-item label="入学日期:" prop="date">
              <el-date-picker v-model="editForm.date" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="logo:" prop="logoUrl">
              <el-upload
                class="avatar-uploader"
                :action="$http.defaults.baseURL + '/file/getFilePath'"
                :headers="$http.defaults.headers.common"
                :data="{ path: 'admissionSchoolLogo/' }"
                name="multipartFile"
                :show-file-list="false"
                :on-success="uploadSuccess"
                accept="image/png,image/jpg,image/jpeg"
              >
                <img v-if="editForm.logoUrl" :src="editForm.logoUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <el-alert title="logo请上传透明的png格式，否则将会覆盖文字显示！！" type="warning" effect="dark" show-icon :closable="false" />
            </el-form-item>
            <el-form-item label="寄语">
              <el-input type="textarea" v-model="editForm.content" style="width: 60%;" rows="7" />
            </el-form-item>
          </el-form>
          <span class="footer">
            <el-button type="primary" @click="save(editForm.id)">保 存</el-button>
          </span>
        </el-card>
      </el-col>
      <el-col :md="14" :sm="12">
        <el-card shadow="never" header="预览">
          <div
            class="logoBg"
            :style="{
              'background-image': 'url(https://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/admission' + editForm.backgroundType + '.jpg)',
            }"
          >
            <div class="title">录取通知书</div>
            <div class="container">
              <div class="idCard" v-if="editForm.idCardState == 1">身份证号：130***********0123</div>
              <div class="studentName">XXX同学：</div>
              <div class="content">{{ editForm.content }}</div>
              <div class="teacherName">校长：{{ editForm.teacherName }}</div>
              <div class="bottom">
                <div>{{ editForm.schoolName }}</div>
                <div>{{ editForm.date }}</div>
              </div>
              <div class="zhang">
                <img :src="editForm.logoUrl" alt="" width="100" />
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { getAdmissionConfig, saveAdmissionConfig } from '../../config/api';
  import * as url from 'url';

  export default {
    name: 'Config',
    data() {
      return {
        editForm: {
          schoolName: '',
          idCardState: null,
          backgroundType: null,
          teacherName: '',
          logoUrl: '',
          date: null,
        },
        editRules: {
          // 表单验证规则
          backgroundType: [{ required: true, message: '请选择背景图样式', trigger: 'change' }],
          idCardState: [{ required: true, message: '请选择是否显示身份证号', trigger: 'change' }],
          date: [{ required: true, message: '请入学日期', trigger: 'change' }],
          logoUrl: [{ required: true, message: '请上传学校印章', trigger: 'blur' }],
          schoolName: [{ required: true, message: '请输入学校名称', trigger: 'blur' }],
          teacherName: [{ required: true, message: '请输入校长姓名', trigger: 'blur' }],
        },
      };
    },
    computed: {
      url() {
        return url;
      },
    },
    created() {
      // 获取录取通知书设置
      this.getConfig();
    },
    methods: {
      // 获取录取通知书设置
      getConfig() {
        getAdmissionConfig().then((res) => {
          if (res.data.resCode == 200) {
            this.editForm = res.data.data;
          }
        });
      },
      // 上传单个照片成功
      uploadSuccess(res) {
        if (res.resCode == 200) {
          this.editForm.logoUrl = res.data[0].fileUrl;
        }
      },
      // 保存录取通知书设置
      save() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            saveAdmissionConfig(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.$message({ type: 'success', message: res.data.resMsg });
                this.getConfig();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .logoBg {
    width: 496px;
    height: 700px;
    position: relative;
    background-size: 100%;
    margin: 0 auto;
  }
  .footer {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
  .title {
    text-align: center;
    padding-top: 50px;
    font-size: 50px;
    font-weight: bolder;
    color: #1a1a1a;
    font-family: 华文楷体;
  }
  .container {
    padding: 0 60px;
    line-height: 30px;
  }
  .idCard {
    font-weight: bold;
    font-size: 16px;
    margin-top: 10px;
  }
  .studentName {
    font-weight: bold;
    font-size: 16px;
    margin-top: 10px;
  }
  .content {
    text-indent: 2em;
    font-size: 16px;
    margin-top: 20px;
  }
  .teacherName {
    margin-top: 150px;
    font-weight: bold;
    font-size: 20px;
  }
  .bottom {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    position: absolute;
    bottom: 60px;
    right: 60px;
    font-size: 16px;
    z-index: 0;
  }
  .zhang {
    position: absolute;
    bottom: 40px;
    right: 60px;
    z-index: 1;
  }
  .el-alert--warning.is-dark {
    color: rgb(25, 137, 250);
    background: rgb(236, 249, 255);
    padding: 0 10px;
  }
</style>
